import React, { useState } from 'react';
import SortingIcon from '../../../assets/icons/icon-sort-copy-2.svg';
import { Typography } from 'src/latest/src/components';
import { useTranslation } from 'react-i18next';
import { SortingConfig, SortingOption } from './ContentSortingInterface';

interface ContentSortingProps {
  selectedOption: string;
  handleSelect: (option: SortingOption) => void;
  sortingByData: SortingConfig;
}

const ContentSorting: React.FC<ContentSortingProps> = ({
  selectedOption,
  handleSelect,
  sortingByData,
}) => {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const { t } = useTranslation('clinicianAvailability');
  const sortingOptions = sortingByData?.sortingOptions || [];

  return (
    <div className="toggle-availability-container">
      <div
        className={`filter-wrapper ${
          selectedOption !== sortingByData?.defaultSorting ? 'sorting' : ''
        }`}
        onClick={() => setIsOpen(!isOpen)}
      >
        <div className="dropdown">
          <div className="dropdown-header ca-dropdown-header">
            <img className="filter-icon" src={SortingIcon} alt="" />
          </div>
          {isOpen && (
            <ul className="dropdown-list" onMouseLeave={() => setIsOpen(false)}>
              <Typography variant="size-12" className="fw-semibold ms-1 ">
                {t('sorting.sortBy')}
              </Typography>
              {sortingOptions &&
                sortingOptions?.length > 0 &&
                sortingOptions?.map((option: SortingOption) => {
                  return (
                    <li
                      className={`dropdown-list-item ${
                        selectedOption === option.unique_key
                          ? 'font-weight-bold'
                          : ''
                      }`}
                      onClick={() => handleSelect(option)}
                    >
                      {option.label}
                    </li>
                  );
                })}
            </ul>
          )}
        </div>
      </div>
    </div>
  );
};

export default ContentSorting;
